import React from 'react';
import clsx from 'clsx';
import { TitleImage } from '../AboutPageGeneralComp';

/**
 * This component is used in markdown component that is rendered in aboutPage page.
 * It contains info about how to add an image
 */
const AddingImage = ({elSubRefs}) => (
    <div id="Group8Sub8" ref ={elSubRefs[7]} className={clsx("subgroup")}>
        <h4 id="Group8Sub8">Adding an image</h4>
        {/**
         * Every TitleImage component contains an image and a title.Title describes the image.
         */}
        <TitleImage 
            title='You can add an image into a "List Items" table row by double clicking on the image block inside your canvas. You can now upload a photo from your pc and select this photo to be inserted into the canvas.'
            srcImg='/images/AboutPageMarkdownImg/15.jpg'
        />
        <TitleImage 
            title='Your photo is now added to the canvas.'
            srcImg='/images/AboutPageMarkdownImg/16.jpg'
        />
    </div> 
)

export default AddingImage;